import {
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-slider',
  templateUrl: './mx.slider.component.html',
  styleUrls: ['./mx.slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MxSliderComponent),
      multi: true,
    },
  ],
})
export class MxSliderComponent
  extends MxBaseComponent
  implements ControlValueAccessor
{
  /**
   * Index of the element in tabbing order.
   */
  @HostBinding('attr.tabindex')
  externalTabindex = '';

  @Input()
  set tabindex(value: number) {
    this._tabindex = value;
    this.externalTabindex = null;
  }

  get tabindex() {
    return this._tabindex;
  }

  private _tabindex: number = null;

  /**
   * Value of the input element.
   */
  @Input('value') _value: number[];
  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  /**
   * Component is visible
   */
  @Input() visible: boolean = true;

  /**
   * When enabled, displays an animation on click of the slider bar.
   */
  @Input() animate: any = true;

  /**
   * When present, it specifies that the element should be disabled.
   */
  @Input() disabled: any = false;

  /**
   * Mininum boundary value.
   */
  @Input() min: number = 0;

  /**
   * Maximum boundary value.
   */
  @Input() max: number = 100;

  /**
   * Orientation of the slider, valid values are horizontal and vertical.
   */
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  /**
   * Step factor to increment/decrement the value.
   */
  @Input() step: number = 1;

  /**
   * When specified, allows two boundary values to be picked.
   */
  @Input() range: boolean = true;

  /**
   * Inline style of the component.
   */
  @Input() style: { [klass: string]: any };

  /**
   * Style class of the component.
   */
  @Input() styleClass: string = 'm-3';

  /**
   * Callback to invoke on value change via slide.
   */
  @Output() mxOnChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Callback to invoke when slide stops.
   */
  @Output() mxOnSlideEnd: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    this.value = value || null;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  mxChange(event: any) {
    this.mxOnChange.emit(event);
  }

  mxSlideEnd(event: any) {
    this.mxOnSlideEnd.emit(event);
  }
}
